// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"3f453d95","921":"4f99adfd"}[chunkId] + ".chunk.js";
};